<template>
    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <div class="flex items-center">
            <div class="flex-shrink-0">
                <ExclamationTriangleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true"/>
            </div>
            <div class="ml-3">
                <p class="text-sm text-yellow-700">
                    <slot></slot>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {ExclamationTriangleIcon} from "@heroicons/vue/24/outline";

export default {
    components: {
        ExclamationTriangleIcon
    }
}
</script>

<style scoped>

</style>
